import { GiTeacher } from "react-icons/gi";
import { FaChalkboardTeacher } from "react-icons/fa";
import { GrGroup } from "react-icons/gr";
import { TiGroup } from "react-icons/ti";
export const widgetData = [
  // { name: "Total Trainings", value: "totalTraining" },
  // { name: "Total Participants", value: "totalParticipants" },
  { name: "Basic Trainings", value: "basicTrainingCount", icon: GiTeacher },
  { name: "Refresher Trainings", value: "refresherTrainingCount", icon: FaChalkboardTeacher },
  { name: "New Basic Trainings", value: "newBasicTrainingCount", icon: GrGroup },
  { name: "Others Trainings", value: "otherTrainingTrainingCount", icon: TiGroup },
];

export const pageTwoChartList = [
  // {
  //   name: "Training - Participants",
  //   yAxisName: "",
  //   xAxisName: "",
  //   value: "trainingParticipantsCombinedBar",
  //   type: "stack",
  // },
  {
    title: "Training Status - Basic",
    yAxisName: "",
    xAxisName: "",
    value: "trainingsScheduledCombinedBar",
    type: "pie",
  },
  {
    title: "Training Status - Refresher",
    yAxisName: "",
    xAxisName: "",
    value: "trainingsCompletedCombinedBar",
    type: "pie",
  },
  {
    title: "Training Status - New Basic",
    yAxisName: "",
    xAxisName: "",
    value: "trainingsOverDueCombinedBar",
    type: "pie",
  },
  {
    title: "Training Status - Others",
    yAxisName: "",
    xAxisName: "",
    value: "otherTrainingStatusChart",
    type: "pie",
  },
  // {
  //   title: "Training Distribution",
  //   value: "trainingDistribution",
  //   type: "pie",
  // },
  {
    title: "Training Categories - Top 5",
    value: "top10TrainingCategories",
    type: "pie",
  },
  {
    title: "Training - Employee Vs Contractor",
    value: "trainingsCountEmployeeVsContractors",
    type: "pie",
  },
  {
    name: "Training - Top 10 Contractors",
    value: "top10ByContractor",
    type: "barWithLabel",
    isMines: true,
    customeTool: true,
  },
  {
    name: "Trainings Completed - Last 12 Months",
    yAxisName: "Count",
    xAxisName: "",
    value: "monthsWiseTraining",
    type: "barWithLabelMonth",
    isMines: true,
  },
];

export const pageOneChartList = [
  {
    name: "Basic Training Distribution - Mines",
    yAxisName: "Count",
    xAxisName: "",
    value: "basicTrainingDistributionMinesWise",
    type: "stack",
    isMines: true,
    isHo: false,
  },
  // {
  //   name: "Other Training Distribution - Mines",
  //   yAxisName: "Count",
  //   xAxisName: "Site",
  //   value: "otherTrainingDistributionMinesWise",
  //   type: "bar",
  // },
  // {
  //   name: "Refresh Training Distribution - Mines",
  //   yAxisName: "Count",
  //   xAxisName: "Site",
  //   value: "refreshTrainingDistributionMinesWise",
  //   type: "bar",
  // },
  // {
  //   name: "New Basic Training Distribution - Mines",
  //   yAxisName: "Count",
  //   xAxisName: "Site",
  //   value: "newBasicTrainingDistributionMinesWise",
  //   type: "bar",
  // },
  {
    name: "Training Completed - Regional Offices",
    yAxisName: "Count",
    xAxisName: "",
    value: "basicTrainingDistributionROWise",
    type: "stack",
    isMines: true,
    isHo: true,
  },
  // {
  //   name: "Other Training Distribution - RO",
  //   yAxisName: "Count",
  //   xAxisName: "Site",
  //   value: "otherTrainingDistributionROWise",
  //   type: "bar",
  // },
  // {
  //   name: "Refresh Training Distribution - RO",
  //   yAxisName: "Count",
  //   xAxisName: "Site",
  //   value: "refreshTrainingDistributionROWise",
  //   type: "bar",
  // },
  // {
  //   name: "New Basic Training Distribution - RO",
  //   yAxisName: "Count",
  //   xAxisName: "Site",
  //   value: "newBasicTrainingDistributionROWise",
  //   type: "bar",
  // },

  {
    name: "Top 5 Categories - Mines",
    value: "top5TrainingCategoriesMinesWise",
    type: "stack",
    isMines: true,
    isHo: false,
  },
  {
    name: "Top 5 Categories - Regional Offices",
    value: "top5TrainingCategoriesRoWise",
    type: "stack",
    isMines: true,
    isHo: true,
  },
  {
    name: "Overdue Trainings - Mines",
    yAxisName: "",
    xAxisName: "",
    value: "overdueTrainingsMines",
    type: "barWithLabel",
    isMines: true,
    customeTool: true,
    isHo: false,
  },
  {
    name: "Overdue Trainings - Regional Offices",
    yAxisName: "",
    xAxisName: "",
    value: "overdueTrainingsROs",
    type: "barWithLabel",
    isMines: true,
    customeTool: true,
    isHo: true,
  },
];
